import { lazy } from 'react'

import { useFeatures } from 'modules/core/hooks/useFeatures'

const GoalDetailPage = lazy(() => import('modules/goals/revamp/pages/GoalDetailPage'))
const MetricGroupPage = lazy(() => import('modules/goals/pages/MetricGroupPage'))

/**
 * Wrapper that renders the revamp GoalDetailPage when the feature flag is active,
 * otherwise falls back to the original MetricGroupPage.
 */
const GoalDetailPageWrapper = () => {
  const { has_dev_goals_revamp, loadingFeatures } = useFeatures(['dev_goals_revamp'])

  if (loadingFeatures) return null

  return has_dev_goals_revamp ? <GoalDetailPage /> : <MetricGroupPage />
}

export default GoalDetailPageWrapper
